module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('createdAt.label'),
      "columns": 6
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "format": "dd/MM/yyyy HH:mm",
      "start-placeholder": "Data Inicial",
      "end-placeholder": "Data Final"
    },
    model: {
      value: (_vm.createdAt),
      callback: function($$v) {
        _vm.createdAt = $$v
      },
      expression: "createdAt"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2851bd2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/exportOrderCsv/filters/marketplace/Colombo.vue
// module id = 3001
// module chunks = 0